export default __webpack_public_path__ + "static/media/icon-route-timer.d0b9ad10.svg";